// src/pages/AdminPanelModals.jsx - İKİ SEVİYELİ KATEGORİ SİSTEMİ İLE GÜNCELLENMİŞ
import React, { useState } from 'react';
import { X, Save, Upload, Percent, Calendar, Tag, Gift, Trash2, Search, ChevronRight, DollarSign, Package, Zap, User, Mail, Phone, MapPin, Clock, Truck, CheckCircle, XCircle, Printer, Send, TrendingUp, AlertCircle, RotateCcw, ChevronDown, ShoppingCart, CreditCard, ShoppingBag, MessageSquare } from 'lucide-react';
import { getCategoryDisplay } from '../config/categoryConfig';
import { CategorySelector } from '../components/CategorySelector';
import { shipOrder } from '../services/orderService';
import toast from 'react-hot-toast';

export function ProductModal({ product, onClose, onSave, categoryConfig }) {
  const [formData, setFormData] = useState(product || {
    name: '',
    category: '',
    price: '',
    stock: '',
    shippingFee: '',
    description: '',
    discount: 0,
    sku: '',
    barcode: '',
    brand: '',
    minStock: 5,
    maxStock: 1000,
    isActive: true,
    isFeatured: false,
    tags: ''
  });

  // 🔥 Mevcut medya (Firebase'deki URL'ler)
  const [existingImages, setExistingImages] = useState(product?.images || []);
  const [existingVideos, setExistingVideos] = useState(product?.videos || []);

  // 🔥 Silinecek medya URL'leri
  const [imagesToDelete, setImagesToDelete] = useState([]);
  const [videosToDelete, setVideosToDelete] = useState([]);

  // Yeni yüklenecek dosyalar
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [videoFiles, setVideoFiles] = useState([]);
  const [videoPreviews, setVideoPreviews] = useState([]);

  const [showCategorySelector, setShowCategorySelector] = useState(false);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const maxSize = 5 * 1024 * 1024;
    const validFiles = files.filter(file => {
      if (file.size > maxSize) {
        alert(`${file.name} dosyası çok büyük! Maksimum 5MB olmalıdır.`);
        return false;
      }
      return true;
    });

    if (validFiles.length === 0) return;

    setImageFiles(prev => [...prev, ...validFiles]);
    const previews = validFiles.map(file => URL.createObjectURL(file));
    setImagePreviews(prev => [...prev, ...previews]);
  };

  const handleVideoChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const maxSize = 50 * 1024 * 1024;
    const validFiles = files.filter(file => {
      if (file.size > maxSize) {
        alert(`${file.name} dosyası çok büyük! Maksimum 50MB olmalıdır.`);
        return false;
      }
      return true;
    });

    if (validFiles.length === 0) return;

    setVideoFiles(prev => [...prev, ...validFiles]);
    const previews = validFiles.map(file => URL.createObjectURL(file));
    setVideoPreviews(prev => [...prev, ...previews]);
  };

  // Yeni eklenen resmi kaldır (henüz yüklenmemiş)
  const removeNewImage = (index) => {
    setImagePreviews(prev => prev.filter((_, i) => i !== index));
    setImageFiles(prev => prev.filter((_, i) => i !== index));
  };

  // Yeni eklenen videoyu kaldır (henüz yüklenmemiş)
  const removeNewVideo = (index) => {
    setVideoPreviews(prev => prev.filter((_, i) => i !== index));
    setVideoFiles(prev => prev.filter((_, i) => i !== index));
  };

  // 🔥 Mevcut resmi kaldır (Firebase'den silinecek)
  const removeExistingImage = (url) => {
    console.log('🗑️ Resim silme işaretlendi:', url);
    setExistingImages(prev => prev.filter(img => img !== url));
    setImagesToDelete(prev => [...prev, url]);
  };

  // 🔥 Mevcut videoyu kaldır (Firebase'den silinecek)
  const removeExistingVideo = (url) => {
    console.log('🗑️ Video silme işaretlendi:', url);
    setExistingVideos(prev => prev.filter(vid => vid !== url));
    setVideosToDelete(prev => [...prev, url]);
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.price) {
      alert('Lütfen ürün adı ve fiyat giriniz!');
      return;
    }

    const price = parseFloat(formData.price);
    const discount = parseFloat(formData.discount) || 0;

    const dataToSave = {
      ...formData,
      price: price,
      originalPrice: price,
      currentPrice: discount > 0 ? price * (1 - discount / 100) : price,
      stock: parseInt(formData.stock) || 0,
      shippingFee: parseInt(formData.shippingFee) || 0,
      discount: discount,
      minStock: parseInt(formData.minStock) || 5,
      maxStock: parseInt(formData.maxStock) || 1000,

      // 🔥 Kalan mevcut medyaları da gönder
      existingImages: existingImages,
      existingVideos: existingVideos,

      // 🔥 Silinecek medyaları gönder
      imagesToDelete: imagesToDelete,
      videosToDelete: videosToDelete
    };

    console.log('📤 Kaydedilecek veri:', {
      mevcutResimler: existingImages.length,
      mevcutVideolar: existingVideos.length,
      yeniResimler: imageFiles.length,
      yeniVideolar: videoFiles.length,
      silinecekResimler: imagesToDelete.length,
      silinecekVideolar: videosToDelete.length
    });

    // Hem resim hem video dosyalarını, hem de silme listelerini gönder
    onSave(dataToSave, imageFiles, videoFiles);
  };

  const categoryDisplay = getCategoryDisplay(formData.category);

  return (
    <div className="modal-overlay">
      <div className="modal modal-large">
        <div className="modal-header">
          <h3>{product ? 'Ürünü Düzenle' : 'Yeni Ürün Ekle'}</h3>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">
          <div className="form-grid">
            {/* Sol Kolon */}
            <div className="form-column">
              <div className="form-group">
                <label className="form-label">Ürün Adı *</label>
                <input
                  className="form-input"
                  type="text"
                  placeholder="Ürün adını giriniz"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Kategori</label>
                  <button
                    type="button"
                    className="category-select-button"
                    onClick={() => setShowCategorySelector(true)}
                  >
                    {formData.category ? (
                      <div className="selected-category">
                        <span className="category-emoji-display">
                          {categoryDisplay.mainEmoji && categoryDisplay.mainEmoji}
                          {categoryDisplay.emoji && categoryDisplay.emoji !== categoryDisplay.mainEmoji && (
                            <> {categoryDisplay.emoji}</>
                          )}
                        </span>
                        <span className="category-text-display">{categoryDisplay.text}</span>
                      </div>
                    ) : (
                      <span className="category-placeholder">Kategori Seçiniz</span>
                    )}
                    <ChevronDown size={18} />
                  </button>
                </div>

                <div className="form-group">
                  <label className="form-label">Marka</label>
                  <input
                    className="form-input"
                    type="text"
                    placeholder="Marka"
                    value={formData.brand}
                    onChange={(e) => setFormData({ ...formData, brand: e.target.value })}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Fiyat (₺) *</label>
                  <input
                    className="form-input"
                    type="number"
                    placeholder="0.00"
                    step="0.01"
                    value={formData.price}
                    onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">İndirim (%)</label>
                  <input
                    className="form-input"
                    type="number"
                    placeholder="0"
                    min="0"
                    max="100"
                    value={formData.discount}
                    onChange={(e) => setFormData({ ...formData, discount: e.target.value })}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Stok</label>
                  <input
                    className="form-input"
                    type="number"
                    placeholder="0"
                    value={formData.stock}
                    onChange={(e) => setFormData({ ...formData, stock: e.target.value })}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Min. Stok (Uyarı)</label>
                  <input
                    className="form-input"
                    type="number"
                    placeholder="5"
                    value={formData.minStock}
                    onChange={(e) => setFormData({ ...formData, minStock: e.target.value })}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Açıklama</label>
                <textarea
                  className="form-input"
                  placeholder="Ürün açıklaması..."
                  rows="4"
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                />
              </div>
            </div>

            {/* Sağ Kolon */}
            <div className="form-column">
              {/* 🔥 Ürün Görselleri */}
              <div className="form-group">
                <label className="form-label">
                  Ürün Görselleri
                  {(existingImages.length > 0 || imagePreviews.length > 0) && (
                    <span className="media-count">
                      ({existingImages.length + imagePreviews.length} resim)
                    </span>
                  )}
                </label>
                <div className="image-upload-area">
                  {/* Mevcut Firebase'deki resimler */}
                  {existingImages.length > 0 && (
                    <div className='image-preview-grid'>
                      <div className="media-section-title">Mevcut Resimler</div>
                      {existingImages.map((img, index) => (
                        <div key={`existing-${index}`} className="media-preview-item">
                          <img
                            src={img}
                            alt={`Mevcut ${index + 1}`}
                            className="image-preview"
                          />
                          <button
                            type="button"
                            className="remove-media-btn"
                            onClick={() => removeExistingImage(img)}
                            title="Resmi sil"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Yeni eklenen resimler */}
                  {imagePreviews.length > 0 && (
                    <div className='image-preview-grid'>
                      <div className="media-section-title">Yeni Eklenecek Resimler</div>
                      {imagePreviews.map((img, index) => (
                        <div key={`new-${index}`} className="media-preview-item new-media">
                          <img
                            src={img}
                            alt={`Yeni ${index + 1}`}
                            className="image-preview"
                          />
                          <button
                            type="button"
                            className="remove-media-btn"
                            onClick={() => removeNewImage(index)}
                            title="Resmi kaldır"
                          >
                            <Trash2 size={16} />
                          </button>
                          <div className="new-badge">YENİ</div>
                        </div>
                      ))}
                    </div>
                  )}

                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageChange}
                    className="form-input"
                  />
                  <p className="upload-hint">
                    <Upload size={16} /> JPG, PNG veya WebP (Max 5MB her biri)
                  </p>
                </div>
              </div>

              {/* 🔥 Ürün Videoları */}
              <div className="form-group">
                <label className="form-label">
                  Ürün Videoları
                  {(existingVideos.length > 0 || videoPreviews.length > 0) && (
                    <span className="media-count">
                      ({existingVideos.length + videoPreviews.length} video)
                    </span>
                  )}
                </label>
                <div className="video-upload-area">
                  {/* Mevcut Firebase'deki videolar */}
                  {existingVideos.length > 0 && (
                    <div className='video-preview-grid'>
                      <div className="media-section-title">Mevcut Videolar</div>
                      {existingVideos.map((video, index) => (
                        <div key={`existing-vid-${index}`} className="media-preview-item">
                          <video
                            src={video}
                            className="video-preview"
                            controls
                          />
                          <button
                            type="button"
                            className="remove-media-btn"
                            onClick={() => removeExistingVideo(video)}
                            title="Videoyu sil"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Yeni eklenen videolar */}
                  {videoPreviews.length > 0 && (
                    <div className='video-preview-grid'>
                      <div className="media-section-title">Yeni Eklenecek Videolar</div>
                      {videoPreviews.map((video, index) => (
                        <div key={`new-vid-${index}`} className="media-preview-item new-media">
                          <video
                            src={video}
                            className="video-preview"
                            controls
                          />
                          <button
                            type="button"
                            className="remove-media-btn"
                            onClick={() => removeNewVideo(index)}
                            title="Videoyu kaldır"
                          >
                            <Trash2 size={16} />
                          </button>
                          <div className="new-badge">YENİ</div>
                        </div>
                      ))}
                    </div>
                  )}

                  <input
                    type="file"
                    accept="video/*"
                    multiple
                    onChange={handleVideoChange}
                    className="form-input"
                  />
                  <p className="upload-hint">
                    <Upload size={16} /> MP4, WebM veya MOV (Max 50MB her biri)
                  </p>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">SKU</label>
                  <input
                    className="form-input"
                    type="text"
                    placeholder="SKU-001"
                    value={formData.sku}
                    onChange={(e) => setFormData({ ...formData, sku: e.target.value })}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Barkod</label>
                  <input
                    className="form-input"
                    type="text"
                    placeholder="1234567890"
                    value={formData.barcode}
                    onChange={(e) => setFormData({ ...formData, barcode: e.target.value })}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Kargo Ücreti</label>
                <input
                  className="form-input"
                  type="number"
                  placeholder="0"
                  value={formData.shippingFee}
                  onChange={(e) => setFormData({ ...formData, shippingFee: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Etiketler (virgülle ayırın)</label>
                <input
                  className="form-input"
                  type="text"
                  placeholder="organik, doğal, glutensiz"
                  value={formData.tags}
                  onChange={(e) => setFormData({ ...formData, tags: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                  />
                  <span>Ürünü Aktif Et (Sitede Görünsün)</span>
                </label>
              </div>

              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={formData.isFeatured}
                    onChange={(e) => setFormData({ ...formData, isFeatured: e.target.checked })}
                  />
                  <span>Öne Çıkan Ürün Yap</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            İptal
          </button>
          <button className="btn btn-primary" onClick={handleSubmit}>
            <Save size={18} /> {product ? 'Güncelle' : 'Kaydet'}
          </button>
        </div>
      </div>

      {/* Kategori Seçici Modal */}
      {showCategorySelector && (
        <CategorySelector
          value={formData.category}
          onChange={(category) => {
            setFormData({ ...formData, category });
            setShowCategorySelector(false);
          }}
          categoryConfig={categoryConfig}
          onClose={() => setShowCategorySelector(false)}
        />
      )}

      <style jsx>{`
        .category-select-button {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 2px solid #e9ecef;
          border-radius: 8px;
          background: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.2s;
          font-family: inherit;
          text-align: left;
        }

        .category-select-button:hover {
          border-color: #E5332A;
          background: #fff5f5;
        }

        .category-select-button:focus {
          outline: none;
          border-color: #E5332A;
          box-shadow: 0 0 0 3px rgba(229, 51, 42, 0.1);
        }

        .selected-category {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          flex: 1;
        }

        .category-emoji-display {
          font-size: 20px;
          line-height: 1;
        }

        .category-text-display {
          font-weight: 600;
          color: #2B2B2B;
        }

        .category-placeholder {
          color: #868e96;
        }

        .media-count {
          color: #868e96;
          font-size: 12px;
          font-weight: 500;
          margin-left: 8px;
        }

        .media-section-title {
          grid-column: 1 / -1;
          font-size: 12px;
          font-weight: 700;
          color: #495057;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 8px;
          padding: 8px 12px;
          background: #f8f9fa;
          border-radius: 6px;
        }

        .image-preview-grid,
        .video-preview-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
          gap: 12px;
          margin-bottom: 12px;
        }

        .media-preview-item {
          position: relative;
          border-radius: 8px;
          overflow: hidden;
          aspect-ratio: 1;
          border: 2px solid #e9ecef;
          transition: all 0.2s;
        }

        .media-preview-item:hover {
          border-color: #adb5bd;
        }

        .media-preview-item.new-media {
          border-color: #06d6a0;
          border-style: dashed;
        }

        .new-badge {
          position: absolute;
          top: 4px;
          left: 4px;
          background: #06d6a0;
          color: white;
          font-size: 9px;
          font-weight: 700;
          padding: 3px 6px;
          border-radius: 4px;
          z-index: 5;
        }

        .image-preview {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
        }

        .video-preview {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
        }

        .remove-media-btn {
          position: absolute;
          top: 4px;
          right: 4px;
          background: rgba(229, 51, 42, 0.9);
          color: white;
          border: none;
          border-radius: 50%;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
          z-index: 10;
        }

        .remove-media-btn:hover {
          background: #E5332A;
          transform: scale(1.1);
        }

        .upload-hint {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          color: #868e96;
          margin-top: 8px;
        }
      `}</style>
    </div>
  );
}

// src/pages/AdminPanelModals.jsx - KAMPANYA MODAL (YENİLENMİŞ)

export function CampaignModal({ campaign, onClose, onSave, categoryConfig, products = [] }) {
  const [formData, setFormData] = useState(campaign || {
    title: '',
    description: '',
    campaignType: 'general', // general/product/category/subcategory
    discountType: 'discount', // discount/free_shipping
    discountPercent: '',
    freeShippingThreshold: '',
    targetId: '',
    targetName: '',
    minPurchase: '',
    startDate: '',
    endDate: ''
  });

  const [showTargetSelector, setShowTargetSelector] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // Hedef display
  const getTargetDisplay = () => {
    console.log('getTargetDisplay çağrıldı:', {
      campaignType: formData.campaignType,
      targetId: formData.targetId,
      targetName: formData.targetName
    });

    // Eğer targetName varsa direkt göster
    if (formData.targetName) {
      return formData.targetName;
    }

    // targetName yoksa targetId'den oluştur
    if (!formData.targetId) {
      return 'Hedef seçiniz';
    }

    if (formData.campaignType === 'product') {
      // Ürün ismini products'tan bul
      const product = products.find(p => p.id === formData.targetId);
      return product ? product.name : formData.targetId;
    }

    if (formData.campaignType === 'category') {
      // Kategori ismini categoryConfig'den bul
      const categoryData = categoryConfig[formData.targetId];
      if (categoryData) {
        return `${categoryData.emoji} ${formData.targetId}`;
      }
      return formData.targetId;
    }

    if (formData.campaignType === 'subcategory') {
      // Alt kategori ismini categoryConfig'den bul
      // targetId = alt kategori key'i
      // targetName olarak kaydedilmiş olmalı (Ana > Alt formatında)
      return formData.targetId;
    }

    return 'Tüm Ürünler';
  };

  const handleSubmit = () => {
    // Validasyon
    if (!formData.title.trim()) {
      alert('Lütfen kampanya başlığı giriniz!');
      return;
    }

    if (formData.discountType === 'discount') {
      if (!formData.discountPercent || formData.discountPercent <= 0) {
        alert('Lütfen geçerli bir indirim oranı giriniz!');
        return;
      }
      if (formData.discountPercent > 100) {
        alert('İndirim oranı %100\'den fazla olamaz!');
        return;
      }
    }

    if (formData.discountType === 'free_shipping') {
      if (!formData.freeShippingThreshold || formData.freeShippingThreshold <= 0) {
        alert('Lütfen geçerli bir minimum tutar giriniz!');
        return;
      }
    }

    if (['product', 'category', 'subcategory'].includes(formData.campaignType) && !formData.targetId) {
      alert('Lütfen hedef seçiniz!');
      return;
    }

    // Tarih kontrolü - boşsa otomatik ata
    const dataToSave = {
      ...formData,
      discountPercent: parseFloat(formData.discountPercent) || 0,
      freeShippingThreshold: parseFloat(formData.freeShippingThreshold) || 0,
      minPurchase: parseFloat(formData.minPurchase) || 0,
      startDate: formData.startDate || new Date().toISOString().split('T')[0],
      endDate: formData.endDate || null // null = süresiz
    };

    onSave(dataToSave);
  };

  return (
    <div className="modal-overlay">
      <div className="modal campaign-modal">
        <div className="modal-header">
          <h3>🎯 {campaign ? 'Kampanyayı Düzenle' : 'Yeni Kampanya Oluştur'}</h3>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">

          {/* ========== KAMPANYA TİPİ ========== */}
          <div className="form-group">
            <label className="form-label">Kampanya Tipi *</label>
            <div className="campaign-type-grid">
              <button
                type="button"
                className={`type-card ${formData.campaignType === 'general' ? 'active' : ''}`}
                onClick={() => setFormData({ ...formData, campaignType: 'general', targetId: '', targetName: '' })}
              >
                <Tag size={20} />
                <strong>Genel</strong>
                <small>Tüm ürünlere uygula</small>
              </button>

              <button
                type="button"
                className={`type-card ${formData.campaignType === 'category' ? 'active' : ''}`}
                onClick={() => setFormData({ ...formData, campaignType: 'category', targetId: '', targetName: '' })}
              >
                <Package size={20} />
                <strong>Kategori</strong>
                <small>Belirli kategoriye</small>
              </button>

              <button
                type="button"
                className={`type-card ${formData.campaignType === 'subcategory' ? 'active' : ''}`}
                onClick={() => setFormData({ ...formData, campaignType: 'subcategory', targetId: '', targetName: '' })}
              >
                <TrendingUp size={20} />
                <strong>Alt Kategori</strong>
                <small>Belirli alt kategoriye</small>
              </button>

              <button
                type="button"
                className={`type-card ${formData.campaignType === 'product' ? 'active' : ''}`}
                onClick={() => setFormData({ ...formData, campaignType: 'product', targetId: '', targetName: '' })}
              >
                <Package size={20} />
                <strong>Tek Ürün</strong>
                <small>Özel ürüne</small>
              </button>
            </div>
          </div>

          {/* ========== HEDEF SEÇİMİ ========== */}
          {['product', 'category', 'subcategory'].includes(formData.campaignType) && (
            <div className="form-group">
              <label className="form-label">
                {formData.campaignType === 'product' && 'Ürün Seçiniz *'}
                {formData.campaignType === 'category' && 'Kategori Seçiniz *'}
                {formData.campaignType === 'subcategory' && 'Alt Kategori Seçiniz *'}
              </label>
              <button
                type="button"
                className="target-select-btn"
                onClick={() => setShowTargetSelector(true)}
              >
                <span>{getTargetDisplay()}</span>
                <ChevronDown size={18} />
              </button>
            </div>
          )}

          {/* ========== İNDİRİM TİPİ ========== */}
          <div className="form-group">
            <label className="form-label">İndirim Tipi *</label>
            <div className="discount-type-grid">
              <button
                type="button"
                className={`discount-type-btn ${formData.discountType === 'discount' ? 'active' : ''}`}
                onClick={() => setFormData({ ...formData, discountType: 'discount' })}
              >
                <Percent size={20} />
                <div>
                  <strong>Yüzde İndirim</strong>
                  <small>Ürün fiyatından % indirim</small>
                </div>
              </button>

              <button
                type="button"
                className={`discount-type-btn ${formData.discountType === 'free_shipping' ? 'active' : ''}`}
                onClick={() => setFormData({ ...formData, discountType: 'free_shipping' })}
              >
                <Package size={20} />
                <div>
                  <strong>Ücretsiz Kargo</strong>
                  <small>Minimum tutarın üzerinde</small>
                </div>
              </button>
            </div>
          </div>

          {/* ========== KAMPANYA BAŞLIĞI ========== */}
          <div className="form-group">
            <label className="form-label">Kampanya Başlığı *</label>
            <input
              className="form-input"
              type="text"
              placeholder="Örn: Kış İndirimi %50"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            />
          </div>

          {/* ========== AÇIKLAMA ========== */}
          <div className="form-group">
            <label className="form-label">Açıklama (Opsiyonel)</label>
            <textarea
              className="form-input"
              placeholder="Kampanya detaylarını giriniz..."
              rows="3"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
          </div>

          {/* ========== İNDİRİM ORANI (İndirim kampanyası için) ========== */}
          {formData.discountType === 'discount' && (
            <div className="form-group">
              <label className="form-label">İndirim Oranı (%) *</label>
              <input
                className="form-input"
                type="number"
                placeholder="20"
                min="1"
                max="100"
                value={formData.discountPercent}
                onChange={(e) => setFormData({ ...formData, discountPercent: e.target.value })}
              />
              <small className="form-hint">1 ile 100 arasında bir değer giriniz</small>
            </div>
          )}

          {/* ========== ÜCRETSİZ KARGO TUTARI (Ücretsiz kargo için) ========== */}
          {formData.discountType === 'free_shipping' && (
            <div className="form-group">
              <label className="form-label">Minimum Alışveriş Tutarı (₺) *</label>
              <input
                className="form-input"
                type="number"
                placeholder="500"
                min="0"
                value={formData.freeShippingThreshold}
                onChange={(e) => setFormData({ ...formData, freeShippingThreshold: e.target.value })}
              />
              <small className="form-hint">Bu tutarın üzerinde kargo ücretsiz olacak</small>
            </div>
          )}

          {/* ========== MİNİMUM ALIŞVERIŞ (İndirim için opsiyonel) ========== */}
          {formData.discountType === 'discount' && (
            <div className="form-group">
              <label className="form-label">Minimum Alışveriş Tutarı (₺) (Opsiyonel)</label>
              <input
                className="form-input"
                type="number"
                placeholder="0"
                min="0"
                value={formData.minPurchase}
                onChange={(e) => setFormData({ ...formData, minPurchase: e.target.value })}
              />
              <small className="form-hint">Boş bırakılırsa minimum tutar olmayacak</small>
            </div>
          )}

          {/* ========== TARİH ARALIĞI ========== */}
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">
                <Calendar size={16} /> Başlangıç Tarihi
              </label>
              <input
                className="form-input"
                type="date"
                value={formData.startDate}
                onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
              />
              <small className="form-hint">Boşsa bugün başlar</small>
            </div>

            <div className="form-group">
              <label className="form-label">
                <Calendar size={16} /> Bitiş Tarihi
              </label>
              <input
                className="form-input"
                type="date"
                min={formData.startDate || new Date().toISOString().split('T')[0]}
                value={formData.endDate}
                onChange={(e) => setFormData({ ...formData, endDate: e.target.value })}
              />
              <small className="form-hint">Boşsa süresiz olur</small>
            </div>
          </div>

          {/* ========== ÖNIZLEME ========== */}
          {formData.discountType === 'discount' && formData.discountPercent > 0 && (
            <div className="campaign-preview">
              <h4>Önizleme</h4>
              <div className="preview-example">
                <div className="preview-price">
                  <span className="old-price">100₺</span>
                  <span className="arrow">→</span>
                  <span className="new-price">
                    {(100 * (1 - formData.discountPercent / 100)).toFixed(2)}₺
                  </span>
                  <span className="discount-badge">%{formData.discountPercent} İndirim</span>
                </div>
              </div>
            </div>
          )}

        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            İptal
          </button>
          <button className="btn btn-primary" onClick={handleSubmit}>
            <Save size={18} /> {campaign ? 'Güncelle' : 'Kampanyayı Oluştur'}
          </button>
        </div>
      </div>

      {/* ========== HEDEF SEÇİCİ MODAL ========== */}
      {showTargetSelector && (
        <TargetSelector
          campaignType={formData.campaignType}
          categoryConfig={categoryConfig}
          products={products}
          onSelect={(targetId, targetName) => {
            setFormData({ ...formData, targetId, targetName });
            setShowTargetSelector(false);
          }}
          onClose={() => setShowTargetSelector(false)}
        />
      )}

      <style jsx>{`
        .campaign-modal {
          max-width: 700px;
          max-height: 90vh;
          overflow-y: auto;
        }

        .campaign-type-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }

        .type-card {
          padding: 16px;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          background: white;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          text-align: center;
          font-family: inherit;
        }

        .type-card:hover {
          border-color: #E5332A;
          background: #fff5f5;
        }

        .type-card.active {
          border-color: #E5332A;
          background: #fff5f5;
          box-shadow: 0 0 0 3px rgba(229, 51, 42, 0.1);
        }

        .type-card svg {
          color: #E5332A;
        }

        .type-card strong {
          font-size: 14px;
          font-weight: 600;
          color: #2B2B2B;
        }

        .type-card small {
          font-size: 12px;
          color: #868e96;
        }

        .target-select-btn {
          width: 100%;
          padding: 12px 16px;
          border: 2px solid #e9ecef;
          border-radius: 8px;
          background: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          font-family: inherit;
          font-size: 14px;
          transition: all 0.2s;
          color: #2B2B2B;
        }

        .target-select-btn:hover {
          border-color: #E5332A;
          background: #fff5f5;
        }

        .discount-type-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }

        .discount-type-btn {
          padding: 16px;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          background: white;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 12px;
          text-align: left;
          font-family: inherit;
        }

        .discount-type-btn:hover {
          border-color: #E5332A;
          background: #fff5f5;
        }

        .discount-type-btn.active {
          border-color: #E5332A;
          background: #fff5f5;
          box-shadow: 0 0 0 3px rgba(229, 51, 42, 0.1);
        }

        .discount-type-btn svg {
          color: #E5332A;
          flex-shrink: 0;
        }

        .discount-type-btn strong {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: #2B2B2B;
          margin-bottom: 4px;
        }

        .discount-type-btn small {
          display: block;
          font-size: 12px;
          color: #868e96;
        }

        .form-hint {
          display: block;
          margin-top: 6px;
          font-size: 12px;
          color: #868e96;
        }

        .campaign-preview {
          margin-top: 20px;
          padding: 20px;
          background: linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%);
          border-radius: 12px;
          border: 2px dashed #E5332A;
        }

        .campaign-preview h4 {
          font-size: 14px;
          font-weight: 600;
          color: #2B2B2B;
          margin-bottom: 12px;
        }

        .preview-example {
          background: white;
          padding: 16px;
          border-radius: 8px;
        }

        .preview-price {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }

        .old-price {
          font-size: 18px;
          color: #868e96;
          text-decoration: line-through;
        }

        .arrow {
          font-size: 20px;
          color: #E5332A;
        }

        .new-price {
          font-size: 24px;
          font-weight: 700;
          color: #E5332A;
        }

        .discount-badge {
          padding: 4px 12px;
          background: #E5332A;
          color: white;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
}

// ==================== HEDEF SEÇİCİ MODAL - DÜZELTİLMİŞ ====================
// ==================== HEDEF SEÇİCİ MODAL - SON DÜZELTİLMİŞ VERSİYON ====================
function TargetSelector({ campaignType, categoryConfig, products, onSelect, onClose }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedCategories, setExpandedCategories] = useState({});

  const filteredCategories = Object.entries(categoryConfig).filter(([key, data]) => {
    const searchLower = searchTerm.toLowerCase();
    const categoryMatch = key.toLowerCase().includes(searchLower);

    const subcategoryMatch = data.subcategories && Object.keys(data.subcategories).some(subKey =>
      subKey.toLowerCase().includes(searchLower)
    );

    return categoryMatch || subcategoryMatch;
  });

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.sku?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleCategory = (categoryKey) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryKey]: !prev[categoryKey]
    }));
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal target-selector-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            {campaignType === 'product' && '📦 Ürün Seçiniz'}
            {campaignType === 'category' && '📂 Kategori Seçiniz'}
            {campaignType === 'subcategory' && '📁 Alt Kategori Seçiniz'}
          </h3>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">
          {/* Arama */}
          <div className="search-box">
            <Search size={18} />
            <input
              type="text"
              placeholder="Ara..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>

          {/* Kategori Seçimi */}
          {campaignType === 'category' && (
            <div className="categories-list">
              {filteredCategories.map(([key, data]) => (
                <button
                  key={key}
                  className="category-item"
                  onClick={() => {
                    console.log('Kategori seçildi:', { id: key, name: key });
                    onSelect(key, key); // ✅ targetId, targetName
                  }}
                >
                  <span className="category-emoji">{data.emoji}</span>
                  <span className="category-name">{key}</span>
                  <ChevronRight size={18} />
                </button>
              ))}
            </div>
          )}

          {/* Alt Kategori Seçimi */}
          {campaignType === 'subcategory' && (
            <div className="categories-list">
              {filteredCategories.map(([key, data]) => (
                <div key={key} className="category-group">
                  <button
                    className="category-header"
                    onClick={() => toggleCategory(key)}
                  >
                    <span className="category-emoji">{data.emoji}</span>
                    <span className="category-name">{key}</span>
                    <ChevronDown
                      size={18}
                      style={{
                        transform: expandedCategories[key] ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s'
                      }}
                    />
                  </button>

                  {expandedCategories[key] && data.subcategories && (
                    <div className="subcategories-list">
                      {Object.entries(data.subcategories).map(([subKey, subData]) => (
                        <button
                          key={subKey}
                          className="subcategory-item"
                          onClick={() => {
                            console.log('Alt kategori seçildi:', {
                              id: subKey,
                              name: `${key} > ${subKey}`
                            });
                            onSelect(subKey, `${key} > ${subKey}`); // ✅ targetId, targetName
                          }}
                        >
                          <span className="subcategory-emoji">{subData.emoji}</span>
                          <span className="subcategory-name">{subKey}</span>
                          <ChevronRight size={16} />
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Ürün Seçimi */}
          {campaignType === 'product' && (
            <div className="products-list">
              {filteredProducts.length > 0 ? (
                filteredProducts.map(product => (
                  <button
                    key={product.id}
                    className="product-item"
                    onClick={() => {
                      console.log('Ürün seçildi:', {
                        id: product.id,
                        name: product.name
                      });
                      onSelect(product.id, product.name); // ✅ targetId, targetName
                    }}
                  >
                    <img
                      src={product.image || product.images?.[0] || 'https://via.placeholder.com/48'}
                      alt={product.name}
                      className="product-img"
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/48?text=No+Image';
                      }}
                    />
                    <div className="product-info">
                      <span className="product-name">{product.name}</span>
                      <span className="product-sku">{product.sku || 'SKU yok'}</span>
                    </div>
                    <ChevronRight size={18} />
                  </button>
                ))
              ) : (
                <div className="empty-state">
                  <Package size={48} />
                  <p>Ürün bulunamadı</p>
                </div>
              )}
            </div>
          )}
        </div>

        <style jsx>{`
          .target-selector-modal {
            max-width: 600px;
            max-height: 80vh;
          }

          .search-box {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 12px;
            border: 2px solid #e9ecef;
            border-radius: 8px;
            margin-bottom: 16px;
          }

          .search-box input {
            flex: 1;
            border: none;
            outline: none;
            font-size: 14px;
            font-family: inherit;
          }

          .categories-list,
          .products-list {
            max-height: 400px;
            overflow-y: auto;
          }

          .category-item,
          .category-header,
          .subcategory-item,
          .product-item {
            width: 100%;
            padding: 12px 16px;
            border: none;
            border-bottom: 1px solid #e9ecef;
            background: white;
            display: flex;
            align-items: center;
            gap: 12px;
            cursor: pointer;
            transition: background 0.2s;
            font-family: inherit;
            text-align: left;
          }

          .category-item:hover,
          .category-header:hover,
          .subcategory-item:hover,
          .product-item:hover {
            background: #f8f9fa;
          }

          .category-emoji,
          .subcategory-emoji {
            font-size: 24px;
          }

          .category-name,
          .subcategory-name {
            flex: 1;
            font-weight: 600;
            color: #2B2B2B;
          }

          .subcategories-list {
            background: #f8f9fa;
            border-left: 3px solid #E5332A;
          }

          .subcategory-item {
            padding-left: 48px;
          }

          .product-img {
            width: 48px;
            height: 48px;
            object-fit: cover;
            border-radius: 8px;
            background: #f8f9fa;
          }

          .product-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .product-name {
            font-weight: 600;
            color: #2B2B2B;
            font-size: 14px;
          }

          .product-sku {
            font-size: 12px;
            color: #868e96;
          }

          .empty-state {
            padding: 60px 20px;
            text-align: center;
            color: #868e96;
          }

          .empty-state svg {
            margin-bottom: 16px;
            opacity: 0.3;
          }

          .categories-list::-webkit-scrollbar,
          .products-list::-webkit-scrollbar {
            width: 6px;
          }

          .categories-list::-webkit-scrollbar-track,
          .products-list::-webkit-scrollbar-track {
            background: #f8f9fa;
            border-radius: 3px;
          }

          .categories-list::-webkit-scrollbar-thumb,
          .products-list::-webkit-scrollbar-thumb {
            background: #dee2e6;
            border-radius: 3px;
          }

          .categories-list::-webkit-scrollbar-thumb:hover,
          .products-list::-webkit-scrollbar-thumb:hover {
            background: #adb5bd;
          }
        `}</style>
      </div>
    </div>
  );
}

// ==================== BULK ACTIONS BAR ====================
export function BulkActionsBar({ count, onDiscount, onDeselect }) {
  return (
    <div className="bulk-actions-bar">
      <span className="bulk-info">✓ {count} ürün seçildi</span>
      <button className="btn btn-primary" onClick={onDiscount}>
        <Percent size={16} /> İndirim Uygula
      </button>
      <button className="btn btn-outline" onClick={onDeselect}>
        <X size={16} /> Seçimi Kaldır
      </button>
    </div>
  );
}

// ==================== ORDER DETAILS MODAL ====================
// AdminPanelModals.jsx içindeki OrderDetailsModal'ı TAMAMEN değiştir:

export function OrderDetailsModal({ order, onClose, onStatusUpdate }) {
  const [notes, setNotes] = useState(order.notes || '');
  const [activeTab, setActiveTab] = useState('details'); // details, timeline, customer
  const [loadingShipment, setLoadingShipment] = useState(false);

  const getStatusColor = (status) => {
    const colors = {
      pending: '#FF9800',
      processing: '#2196F3',
      shipped: '#9C27B0',
      delivered: '#4CAF50',
      cancelled: '#E5332A',
      returned: '#FF9800'
    };
    return colors[status] || '#868e96';
  };

  const getStatusIcon = (status) => {
    const icons = {
      pending: Clock,
      processing: Package,
      shipped: Truck,
      delivered: CheckCircle,
      cancelled: XCircle,
      returned: RotateCcw
    };
    return icons[status] || AlertCircle;
  };

  const getStatusText = (status) => {
    const texts = {
      pending: 'Beklemede',
      processing: 'Hazırlanıyor',
      shipped: 'Kargoda',
      delivered: 'Teslim Edildi',
      cancelled: 'İptal Edildi',
      returned: 'İade Edildi'
    };
    return texts[status] || status;
  };

  const StatusIcon = getStatusIcon(order.status);

  const handlePrint = () => {
    window.print();
  };

  const handleSendEmail = () => {
    const subject = `Sipariş Bilgilendirme - ${order.orderNumber}`;
    const body = `Merhaba,\n\n${order.orderNumber} numaralı siparişiniz hakkında bilgilendirme...`;
    window.location.href = `mailto:${order.customerEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  // ✅ YENİ FONKSİYON: Kargoya Ver
  const handleShipOrder = async () => {
    if (!window.confirm('Bu siparişi Sürat Kargo ile kargoya vermek istediğinize emin misiniz?')) {
      return;
    }

    setLoadingShipment(true);

    try {
      const result = await shipOrder(order.id);

      if (result.success) {
        toast.success(`✅ Kargoya verildi!\n\nTakip No: ${result.trackingNumber}\nKargo: ${result.carrier}`, {
          duration: 6000,
          style: {
            background: '#4CAF50',
            color: 'white',
            fontSize: '15px',
            padding: '16px'
          }
        });

        // Mock uyarısı
        if (result.message?.includes('TEST MODE')) {
          toast('⚠️ ' + result.message, {
            icon: '🧪',
            duration: 4000
          });
        }

        onClose(); // Modal'ı kapat
        // Parent component fetchAllData'yı çağıracak
      } else {
        toast.error(`❌ Kargo Hatası\n\n${result.error}`, {
          duration: 6000,
          style: {
            fontSize: '14px'
          }
        });

        if (result.requiresManualAction) {
          toast('👨‍💼 Manuel işlem gerekiyor. Lütfen Sürat Kargo paneline giriş yapıp manuel olarak kargo oluşturun.', {
            icon: '⚠️',
            duration: 6000
          });
        }
      }
    } catch (error) {
      console.error('❌ Kargoya verme hatası:', error);
      toast.error('Bir hata oluştu: ' + error.message);
    } finally {
      setLoadingShipment(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal modal-order-details" onClick={(e) => e.stopPropagation()}>
          {/* HEADER */}
          <div className="order-modal-header">
            <div className="order-modal-header-left">
              <div className="order-modal-icon">
                <ShoppingCart size={28} />
              </div>
              <div>
                <h2 className="order-modal-title">Sipariş Detayları</h2>
                <p className="order-modal-subtitle">#{order.orderNumber}</p>
              </div>
            </div>

            <div className="order-modal-header-right">
              <div className="order-status-badge-large" style={{
                background: `${getStatusColor(order.status)}15`,
                border: `2px solid ${getStatusColor(order.status)}`
              }}>
                <StatusIcon size={20} color={getStatusColor(order.status)} />
                <span style={{ color: getStatusColor(order.status) }}>
                  {getStatusText(order.status)}
                </span>
              </div>

              <button className="modal-close-btn" onClick={onClose}>
                <X size={24} />
              </button>
            </div>
          </div>

          {/* TABS */}
          <div className="order-modal-tabs">
            <button
              className={`order-modal-tab ${activeTab === 'details' ? 'active' : ''}`}
              onClick={() => setActiveTab('details')}
            >
              <Package size={18} />
              Sipariş Bilgileri
            </button>
            <button
              className={`order-modal-tab ${activeTab === 'timeline' ? 'active' : ''}`}
              onClick={() => setActiveTab('timeline')}
            >
              <Clock size={18} />
              Takip
            </button>
            <button
              className={`order-modal-tab ${activeTab === 'customer' ? 'active' : ''}`}
              onClick={() => setActiveTab('customer')}
            >
              <User size={18} />
              Müşteri
            </button>
          </div>

          {/* CONTENT */}
          <div className="order-modal-body">
            {/* TAB: DETAILS */}
            {activeTab === 'details' && (
              <>
                {/* Order Info Cards */}
                <div className="order-info-cards">
                  <div className="order-info-card">
                    <div className="order-info-card-icon" style={{ background: 'rgba(33, 150, 243, 0.1)' }}>
                      <Calendar size={22} color="#2196F3" />
                    </div>
                    <div className="order-info-card-content">
                      <span className="order-info-card-label">Sipariş Tarihi</span>
                      <span className="order-info-card-value">
                        {new Date(order.createdAt).toLocaleDateString('tr-TR', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </span>
                    </div>
                  </div>

                  <div className="order-info-card">
                    <div className="order-info-card-icon" style={{ background: 'rgba(76, 175, 80, 0.1)' }}>
                      <DollarSign size={22} color="#4CAF50" />
                    </div>
                    <div className="order-info-card-content">
                      <span className="order-info-card-label">Toplam Tutar</span>
                      <span className="order-info-card-value">
                        {order.total?.toFixed(2)} ₺
                      </span>
                    </div>
                  </div>

                  <div className="order-info-card">
                    <div className="order-info-card-icon" style={{ background: 'rgba(156, 39, 176, 0.1)' }}>
                      <CreditCard size={22} color="#9C27B0" />
                    </div>
                    <div className="order-info-card-content">
                      <span className="order-info-card-label">Ödeme Yöntemi</span>
                      <span className="order-info-card-value">
                        {order.paymentMethod === 'credit-card' ? 'Kredi Kartı' : 'Kapıda Ödeme'}
                      </span>
                    </div>
                  </div>

                  <div className="order-info-card">
                    <div className="order-info-card-icon" style={{ background: 'rgba(255, 152, 0, 0.1)' }}>
                      <Package size={22} color="#FF9800" />
                    </div>
                    <div className="order-info-card-content">
                      <span className="order-info-card-label">Ürün Sayısı</span>
                      <span className="order-info-card-value">
                        {order.items?.length || 0} Ürün
                      </span>
                    </div>
                  </div>
                </div>

                {/* Products List */}
                <div className="order-section">
                  <div className="order-section-header">
                    <ShoppingBag size={20} />
                    <h3>Sipariş Ürünleri</h3>
                  </div>

                  <div className="order-products-list">
                    {order.items?.map((item, index) => {
                      const itemName = item.productName || item.name || item.title || 'Ürün';
                      const itemImage = item.productImage || item.image || item.imageUrl
                        || (Array.isArray(item.images) ? item.images[0] : '')
                        || '';
                      const itemPrice = Number(item.price || item.currentPrice || 0);
                      const itemQty = Number(item.quantity || 1);
                      const itemShipping = Number(item.shippingFee || 0);
                      const itemSku = item.sku || item.productSku || '';

                      return (
                        <div key={index} className="order-product-item">
                          <div className="order-product-image">
                            {itemImage ? (
                              <img src={itemImage} alt={itemName} />
                            ) : (
                              <div className="order-product-image-placeholder">
                                <Package size={24} />
                              </div>
                            )}
                          </div>

                          <div className="order-product-details">
                            <h4 className="order-product-name">{itemName}</h4>
                            {itemSku && (
                              <span className="order-product-sku">SKU: {itemSku}</span>
                            )}
                            {itemShipping > 0 && (
                              <span style={{
                                fontSize: '12px',
                                color: '#868e96',
                                marginTop: '4px',
                                display: 'block'
                              }}>
                                🚚 Kargo: {itemShipping.toFixed(2)} ₺
                              </span>
                            )}
                          </div>

                          <div className="order-product-quantity">
                            <span className="order-product-quantity-label">Adet</span>
                            <span className="order-product-quantity-value">{itemQty}</span>
                          </div>

                          <div className="order-product-price">
                            <span className="order-product-unit-price">{itemPrice.toFixed(2)} ₺</span>
                            <span className="order-product-total-price">
                              {(itemPrice * itemQty).toFixed(2)} ₺
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Price Summary */}
                <div className="order-section">
                  <div className="order-section-header">
                    <DollarSign size={20} />
                    <h3>Fiyat Özeti</h3>
                  </div>

                  <div className="order-price-summary">
                    <div className="order-price-row">
                      <span>Ürün Toplamı</span>
                      <span>
                        {(order.subtotal ?? (order.items?.reduce(
                          (s, i) => s + Number(i.price || 0) * Number(i.quantity || 1), 0
                        ) ?? 0)).toFixed(2)} ₺
                      </span>
                    </div>

                    {(order.discount || 0) > 0 && (
                      <div className="order-price-row discount">
                        <span>İndirim</span>
                        <span>-{Number(order.discount).toFixed(2)} ₺</span>
                      </div>
                    )}

                    {/* Kargo: her ürünün shippingFee'si zaten adet × birim kargo olarak kaydedilmiş */}
                    {(() => {
                      const shippingTotal = (order.items || [])
                        .reduce((s, i) => s + Number(i.shippingFee || 0) * Number(i.quantity || 1), 0);

                      return (
                        <div className="order-price-row">
                          <span>Kargo Ücreti</span>
                          <span style={{ color: shippingTotal === 0 ? '#4CAF50' : undefined }}>
                            {shippingTotal > 0 ? `${shippingTotal.toFixed(2)} ₺` : 'Ücretsiz'}
                          </span>
                        </div>
                      );
                    })()}

                    {(order.tax || 0) > 0 && (
                      <div className="order-price-row">
                        <span>KDV (%{order.taxRate || 18})</span>
                        <span>{Number(order.tax).toFixed(2)} ₺</span>
                      </div>
                    )}

                    <div className="order-price-divider"></div>

                    {/* Genel toplam: order.total kargosuz kaydedildiği için items'dan hesapla */}
                    {(() => {
                      const itemsTotal = (order.items || [])
                        .reduce((s, i) => s + Number(i.price || 0) * Number(i.quantity || 1), 0);
                      const shippingTotal = (order.items || [])
                        .reduce((s, i) => s + Number(i.shippingFee || 0) * Number(i.quantity || 1), 0);
                      const discount = Number(order.discount || 0);
                      const tax = Number(order.tax || 0);
                      const grandTotal = itemsTotal + shippingTotal - discount + tax;

                      return (
                        <div className="order-price-row total">
                          <span>Genel Toplam</span>
                          <span>{grandTotal.toFixed(2)} ₺</span>
                        </div>
                      );
                    })()}
                  </div>
                </div>

                {/* Notes */}
                <div className="order-section">
                  <div className="order-section-header">
                    <MessageSquare size={20} />
                    <h3>Sipariş Notları</h3>
                  </div>

                  <textarea
                    className="order-notes-textarea"
                    rows="4"
                    placeholder="Sipariş hakkında notlarınızı buraya yazın..."
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                </div>
              </>
            )}

            {/* TAB: TIMELINE */}
            {activeTab === 'timeline' && (
              <div className="order-section">
                <div className="order-section-header">
                  <TrendingUp size={20} />
                  <h3>Sipariş Takibi</h3>
                </div>

                {/* ✅ KARGO HATASI BANNER */}
                {order.cargoError && (
                  <div style={{
                    background: '#FFEBEE',
                    border: '2px solid #E5332A',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    marginBottom: '1.5rem'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '1rem'
                    }}>
                      <div style={{
                        background: '#E5332A',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                      }}>
                        <AlertCircle size={24} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <h4 style={{ margin: '0 0 0.5rem 0', color: '#C62828', fontSize: '16px' }}>
                          ⚠️ Kargo Oluşturulamadı
                        </h4>
                        <p style={{ margin: '0 0 0.5rem 0', color: '#666', fontSize: '14px' }}>
                          {order.cargoError.message}
                        </p>
                        <p style={{ margin: '0', fontSize: '13px', color: '#868e96' }}>
                          Son deneme: {new Date(order.cargoError.attemptedAt).toLocaleString('tr-TR')}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* ✅ TAKİP NUMARASI BANNER (Kargo başarılıysa) */}
                {order.trackingNumber && (
                  <div style={{
                    background: '#E8F5E9',
                    border: '2px solid #4CAF50',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    marginBottom: '1.5rem'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: '1rem'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem'
                      }}>
                        <Truck size={24} color="#4CAF50" />
                        <h4 style={{ margin: 0, color: '#2E7D32', fontSize: '16px' }}>
                          Kargoya Verildi
                        </h4>
                      </div>
                      <span style={{
                        background: '#4CAF50',
                        color: 'white',
                        padding: '0.25rem 0.75rem',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontWeight: '600'
                      }}>
                        {order.carrier || 'Sürat Kargo'}
                      </span>
                    </div>

                    <div style={{
                      background: 'white',
                      padding: '1rem',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                      <div>
                        <span style={{ fontSize: '12px', color: '#666', display: 'block' }}>
                          Takip Numarası
                        </span>
                        <span style={{
                          fontSize: '20px',
                          fontWeight: '700',
                          color: '#2E7D32',
                          fontFamily: 'monospace',
                          letterSpacing: '1px'
                        }}>
                          {order.trackingNumber}
                        </span>
                      </div>
                      <button
                        className="btn btn-sm"
                        style={{ background: '#4CAF50', color: 'white' }}
                        onClick={() => {
                          navigator.clipboard.writeText(order.trackingNumber);
                          toast.success('Takip numarası kopyalandı!');
                        }}
                      >
                        📋 Kopyala
                      </button>
                    </div>


                    <a href={`https://gonderitakip.suratkargo.com.tr/Home/Track?code=${order.trackingNumber}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        marginTop: '1rem',
                        color: '#2E7D32',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}
                    >
                      🔍 Sürat Kargo'da Takip Et →
                    </a>
                  </div>
                )}

                <div className="order-timeline">
                  {order.timeline?.map((event, index) => {
                    const EventIcon = getStatusIcon(event.status);
                    const color = getStatusColor(event.status);

                    return (
                      <div key={index} className="order-timeline-item">
                        <div className="order-timeline-icon" style={{
                          background: `${color}15`,
                          border: `2px solid ${color}`
                        }}>
                          <EventIcon size={18} color={color} />
                        </div>

                        <div className="order-timeline-content">
                          <div className="order-timeline-header">
                            <h4 className="order-timeline-title">{event.action}</h4>
                            <span className="order-timeline-time">
                              {new Date(event.date).toLocaleString('tr-TR', {
                                day: 'numeric',
                                month: 'short',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </span>
                          </div>

                          {event.reason && (
                            <p className="order-timeline-description">
                              Neden: {event.reason}
                            </p>
                          )}

                          {event.trackingNumber && (
                            <p className="order-timeline-description">
                              Takip No: {event.trackingNumber}
                            </p>
                          )}

                          <span className="order-timeline-user">
                            {event.updatedBy}
                          </span>
                        </div>

                        {index < order.timeline.length - 1 && (
                          <div className="order-timeline-line"></div>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Quick Actions */}
                {order.status !== 'cancelled' && order.status !== 'delivered' && (
                  <div className="order-quick-actions">
                    <h4 className="order-quick-actions-title">Hızlı İşlemler</h4>
                    <div className="order-quick-actions-buttons">
                      {order.status === 'pending' && (
                        <>
                          <button
                            className="order-action-btn primary"
                            onClick={() => {
                              onStatusUpdate(order.id, 'processing');
                              onClose();
                            }}
                          >
                            <Package size={18} />
                            Hazırlamaya Başla
                          </button>
                        </>
                      )}

                      {/* ✅ PROCESSING → Kargoya Ver (Sürat Kargo ile) */}
                      {order.status === 'processing' && (
                        <button
                          className="order-action-btn primary"
                          style={{
                            background: '#9C27B0',
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem'
                          }}
                          onClick={handleShipOrder}
                          disabled={loadingShipment}
                        >
                          {loadingShipment ? (
                            <>
                              <div style={{
                                width: '16px',
                                height: '16px',
                                border: '2px solid rgba(255, 255, 255, 0.3)',
                                borderTopColor: 'white',
                                borderRadius: '50%',
                                animation: 'spin 0.8s linear infinite'
                              }}></div>
                              Kargoya Veriliyor...
                            </>
                          ) : (
                            <>
                              <Truck size={18} />
                              📦 Sürat Kargo ile Gönder
                            </>
                          )}
                        </button>
                      )}

                      {order.status === 'shipped' && (
                        <button
                          className="order-action-btn success"
                          onClick={() => {
                            onStatusUpdate(order.id, 'delivered');
                            onClose();
                          }}
                        >
                          <CheckCircle size={18} />
                          Teslim Edildi Olarak İşaretle
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* TAB: CUSTOMER */}
            {activeTab === 'customer' && (
              <>
                <div className="order-section">
                  <div className="order-section-header">
                    <User size={20} />
                    <h3>Müşteri Bilgileri</h3>
                  </div>

                  <div className="customer-info-grid">
                    <div className="customer-info-item">
                      <User size={18} color="#868e96" />
                      <div>
                        <span className="customer-info-label">Ad Soyad</span>
                        <span className="customer-info-value">{order.customerName}</span>
                      </div>
                    </div>

                    <div className="customer-info-item">
                      <Mail size={18} color="#868e96" />
                      <div>
                        <span className="customer-info-label">E-posta</span>
                        <span className="customer-info-value">{order.customerEmail}</span>
                      </div>
                    </div>

                    {order.customerPhone && (
                      <div className="customer-info-item">
                        <Phone size={18} color="#868e96" />
                        <div>
                          <span className="customer-info-label">Telefon</span>
                          <span className="customer-info-value">{order.customerPhone}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {order.shippingAddress && (
                  <div className="order-section">
                    <div className="order-section-header">
                      <MapPin size={20} />
                      <h3>Teslimat Adresi</h3>
                    </div>

                    <div className="address-card">
                      <div className="address-header">
                        <strong>{order.shippingAddress.firstName} {order.shippingAddress.lastName}</strong>
                        {order.shippingAddress.title && (
                          <span className="address-title">{order.shippingAddress.title}</span>
                        )}
                      </div>
                      <p className="address-text">{order.shippingAddress.address}</p>
                      <p className="address-location">
                        {order.shippingAddress.district} / {order.shippingAddress.city}
                      </p>
                      {order.shippingAddress.zipCode && (
                        <p className="address-zip">Posta Kodu: {order.shippingAddress.zipCode}</p>
                      )}
                      <p className="address-phone">
                        <Phone size={14} /> {order.shippingAddress.phone}
                      </p>
                    </div>
                  </div>
                )}

                {order.billingAddress && order.billingAddress !== order.shippingAddress && (
                  <div className="order-section">
                    <div className="order-section-header">
                      <CreditCard size={20} />
                      <h3>Fatura Adresi</h3>
                    </div>

                    <div className="address-card">
                      <div className="address-header">
                        <strong>{order.billingAddress.firstName} {order.billingAddress.lastName}</strong>
                      </div>
                      <p className="address-text">{order.billingAddress.address}</p>
                      <p className="address-location">
                        {order.billingAddress.district} / {order.billingAddress.city}
                      </p>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>

          {/* FOOTER */}
          <div className="order-modal-footer">
            <div className="order-modal-footer-left">
              <button className="order-footer-btn" onClick={handlePrint}>
                <Printer size={18} />
                Yazdır
              </button>
              <button className="order-footer-btn" onClick={handleSendEmail}>
                <Send size={18} />
                E-posta Gönder
              </button>
            </div>

            <div className="order-modal-footer-right">
              <button className="order-footer-btn secondary" onClick={onClose}>
                Kapat
              </button>
              <button className="order-footer-btn primary">
                <Save size={18} />
                Notları Kaydet
              </button>
            </div>
          </div>
        </div>

        <style jsx>{`
        /* MODAL BASE */
        .modal-order-details {
          max-width: 1000px;
          width: 95%;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          padding: 0;
        }

        /* HEADER */
        .order-modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 2rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
        }

        .order-modal-header-left {
          display: flex;
          align-items: center;
          gap: 1.5rem;
        }

        .order-modal-icon {
          width: 60px;
          height: 60px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(10px);
        }

        .order-modal-title {
          font-size: 24px;
          font-weight: 700;
          margin: 0 0 0.25rem 0;
        }

        .order-modal-subtitle {
          font-size: 14px;
          margin: 0;
          opacity: 0.9;
        }

        .order-modal-header-right {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .order-status-badge-large {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.75rem 1.5rem;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          background: white;
        }

        .modal-close-btn {
          width: 40px;
          height: 40px;
          border: none;
          background: rgba(255, 255, 255, 0.2);
          color: white;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
        }

        .modal-close-btn:hover {
          background: rgba(255, 255, 255, 0.3);
        }

        /* TABS */
        .order-modal-tabs {
          display: flex;
          background: #f8f9fa;
          border-bottom: 2px solid #e9ecef;
        }

        .order-modal-tab {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          padding: 1rem;
          border: none;
          background: transparent;
          color: #495057;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          position: relative;
        }

        .order-modal-tab:hover {
          background: #e9ecef;
        }

        .order-modal-tab.active {
          color: #667eea;
          background: white;
        }

        .order-modal-tab.active::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: #667eea;
        }

        /* BODY */
        .order-modal-body {
          flex: 1;
          overflow-y: auto;
          padding: 2rem;
        }

        /* INFO CARDS */
        .order-info-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .order-info-card {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1.5rem;
          background: white;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          transition: all 0.2s;
        }

        .order-info-card:hover {
          border-color: #667eea;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
        }

        .order-info-card-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .order-info-card-content {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        .order-info-card-label {
          font-size: 12px;
          color: #868e96;
          font-weight: 500;
        }

        .order-info-card-value {
          font-size: 16px;
          font-weight: 700;
          color: #2B2B2B;
        }

        /* SECTIONS */
        .order-section {
          background: white;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          padding: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .order-section-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #f0f0f0;
        }

        .order-section-header h3 {
          font-size: 18px;
          font-weight: 700;
          color: #2B2B2B;
          margin: 0;
        }

        /* PRODUCTS LIST */
        .order-products-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .order-product-item {
          display: grid;
          grid-template-columns: 80px 1fr auto auto;
          gap: 1.5rem;
          align-items: center;
          padding: 1rem;
          background: #f8f9fa;
          border-radius: 10px;
          transition: all 0.2s;
        }

        .order-product-item:hover {
          background: #e9ecef;
        }

        .order-product-image {
          width: 80px;
          height: 80px;
          border-radius: 8px;
          overflow: hidden;
          background: white;
          border: 2px solid #e9ecef;
        }

        .order-product-image img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .order-product-image-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #adb5bd;
        }

        .order-product-details {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        .order-product-name {
          font-size: 15px;
          font-weight: 600;
          color: #2B2B2B;
          margin: 0;
        }

        .order-product-category {
          font-size: 13px;
          color: #868e96;
          margin: 0;
        }

        .order-product-sku {
          font-size: 11px;
          color: #adb5bd;
          font-family: monospace;
        }

        .order-product-quantity {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.25rem;
          padding: 0.5rem 1rem;
          background: white;
          border-radius: 8px;
        }

        .order-product-quantity-label {
          font-size: 11px;
          color: #868e96;
        }

        .order-product-quantity-value {
          font-size: 18px;
          font-weight: 700;
          color: #2B2B2B;
        }

        .order-product-price {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 0.25rem;
        }

        .order-product-unit-price {
          font-size: 12px;
          color: #868e96;
        }

        .order-product-total-price {
          font-size: 18px;
          font-weight: 700;
          color: #667eea;
        }

        /* PRICE SUMMARY */
        .order-price-summary {
          background: #f8f9fa;
          border-radius: 10px;
          padding: 1.5rem;
        }

        .order-price-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem 0;
          font-size: 14px;
        }

        .order-price-row.discount {
          color: #E5332A;
        }

        .order-price-divider {
          height: 2px;
          background: #e9ecef;
          margin: 0.5rem 0;
        }

        .order-price-row.total {
          font-size: 20px;
          font-weight: 700;
          color: #2B2B2B;
        }

        .order-price-row.total span:last-child {
          color: #667eea;
        }

        /* NOTES */
        .order-notes-textarea {
          width: 100%;
          padding: 1rem;
          border: 2px solid #e9ecef;
          border-radius: 8px;
          font-size: 14px;
          font-family: inherit;
          resize: vertical;
          transition: all 0.2s;
        }

        .order-notes-textarea:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        /* TIMELINE */
        .order-timeline {
          position: relative;
        }

        .order-timeline-item {
          position: relative;
          display: flex;
          gap: 1.5rem;
          padding-bottom: 2rem;
        }

        .order-timeline-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          z-index: 2;
        }

        .order-timeline-line {
          position: absolute;
          left: 19px;
          top: 40px;
          bottom: 0;
          width: 2px;
          background: #e9ecef;
        }

        .order-timeline-content {
          flex: 1;
          padding-top: 0.25rem;
        }

        .order-timeline-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.5rem;
        }

        .order-timeline-title {
          font-size: 15px;
          font-weight: 600;
          color: #2B2B2B;
          margin: 0;
        }

        .order-timeline-time {
          font-size: 12px;
          color: #868e96;
        }

        .order-timeline-description {
          font-size: 13px;
          color: #495057;
          margin: 0.5rem 0;
        }

        .order-timeline-user {
          font-size: 12px;
          color: #868e96;
          font-style: italic;
        }

        /* QUICK ACTIONS */
        .order-quick-actions {
          margin-top: 2rem;
          padding-top: 2rem;
          border-top: 2px solid #e9ecef;
        }

        .order-quick-actions-title {
          font-size: 16px;
          font-weight: 600;
          margin: 0 0 1rem 0;
          color: #2B2B2B;
        }

        .order-quick-actions-buttons {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .order-action-btn {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.75rem 1.5rem;
          border: 2px solid;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
        }

        .order-action-btn.primary {
          background: #2196F3;
          border-color: #2196F3;
          color: white;
        }

        .order-action-btn.primary:hover {
          background: #1976D2;
          border-color: #1976D2;
        }

        .order-action-btn.success {
          background: #4CAF50;
          border-color: #4CAF50;
          color: white;
        }

        .order-action-btn.success:hover {
          background: #388E3C;
          border-color: #388E3C;
        }

        .order-action-btn.danger {
          background: #E5332A;
          border-color: #E5332A;
          color: white;
        }

        .order-action-btn.danger:hover {
          background: #C62828;
          border-color: #C62828;
        }

        /* CUSTOMER INFO */
        .customer-info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1rem;
        }

        .customer-info-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: #f8f9fa;
          border-radius: 8px;
        }

        .customer-info-item > div {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        .customer-info-label {
          font-size: 12px;
          color: #868e96;
        }

        .customer-info-value {
          font-size: 14px;
          font-weight: 600;
          color: #2B2B2B;
        }

        /* ADDRESS CARD */
        .address-card {
          padding: 1.5rem;
          background: #f8f9fa;
          border-radius: 10px;
          border-left: 4px solid #667eea;
        }

        .address-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }

        .address-title {
          padding: 0.25rem 0.75rem;
          background: #667eea;
          color: white;
          border-radius: 6px;
          font-size: 11px;
          font-weight: 600;
        }

        .address-text,
        .address-location,
        .address-zip,
        .address-phone {
          margin: 0.5rem 0;
          font-size: 14px;
          color: #495057;
          line-height: 1.6;
        }

        .address-phone {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-weight: 600;
        }

        /* FOOTER */
        .order-modal-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5rem 2rem;
          background: #f8f9fa;
          border-top: 2px solid #e9ecef;
        }

        .order-modal-footer-left,
        .order-modal-footer-right {
          display: flex;
          gap: 1rem;
        }

        .order-footer-btn {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.75rem 1.5rem;
          border: 2px solid #e9ecef;
          background: white;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          color: #495057;
        }

        .order-footer-btn:hover {
          border-color: #667eea;
          color: #667eea;
        }

        .order-footer-btn.secondary {
          background: #e9ecef;
        }

        .order-footer-btn.primary {
          background: #667eea;
          border-color: #667eea;
          color: white;
        }

        .order-footer-btn.primary:hover {
          background: #5568d3;
          border-color: #5568d3;
        }

        /* RESPONSIVE */
        @media (max-width: 768px) {
          .modal-order-details {
            width: 100%;
            max-height: 100vh;
            border-radius: 0;
          }

          .order-modal-header {
            padding: 1.5rem;
          }

          .order-modal-header-left {
            gap: 1rem;
          }

          .order-modal-icon {
            width: 48px;
            height: 48px;
          }

          .order-modal-title {
            font-size: 20px;
          }

          .order-info-cards {
            grid-template-columns: 1fr;
          }

          .order-product-item {
            grid-template-columns: 1fr;
            gap: 1rem;
          }

          .customer-info-grid {
            grid-template-columns: 1fr;
          }

          .order-modal-footer {
            flex-direction: column;
            gap: 1rem;
          }

          .order-modal-footer-left,
          .order-modal-footer-right {
            width: 100%;
          }

          .order-footer-btn {
            flex: 1;
            justify-content: center;
          }
        }

        /* PRINT STYLES */
        @media print {
          .modal-overlay {
            position: static;
            background: white;
          }

          .modal-order-details {
            max-width: 100%;
            max-height: none;
            box-shadow: none;
          }

          .modal-close-btn,
          .order-modal-tabs,
          .order-quick-actions,
          .order-modal-footer {
            display: none !important;
          }
        }
      `}</style>
      </div>
    </div>
  );
}

// ==================== CUSTOMER DETAILS MODAL ====================
export function CustomerDetailsModal({ customer, orders = [], onClose }) {
  console.log('👤 CustomerDetailsModal açıldı:', {
    customerId: customer.id,
    customerEmail: customer.email,
    customerName: customer.name,
    ordersReceived: orders.length,
    orders: orders.map(o => ({
      id: o.id,
      orderNumber: o.orderNumber,
      customerId: o.customerId,
      customerEmail: o.customerEmail,
      total: o.total
    }))
  });

  const customerStats = {
    totalOrders: orders.length,
    totalSpent: orders.reduce((sum, o) => sum + (o.total || 0), 0),
    avgOrderValue: orders.length > 0
      ? orders.reduce((sum, o) => sum + (o.total || 0), 0) / orders.length
      : 0,
    lastOrderDate: orders.length > 0
      ? Math.max(...orders.map(o => new Date(o.createdAt).getTime()))
      : null
  };

  const isVIP = customerStats.totalOrders >= 10;

  console.log('📊 Müşteri istatistikleri:', customerStats);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Müşteri Detayları</h3>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">
          {/* Customer Profile */}
          <div className="customer-profile" style={{
            display: 'flex',
            gap: '1.5rem',
            padding: '2rem',
            background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)',
            borderRadius: '12px',
            marginBottom: '2rem'
          }}>
            <div className="customer-avatar-large" style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #E5332A, #ff6b6b)',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '40px',
              fontWeight: '700',
              flexShrink: 0,
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}>
              {customer.name?.charAt(0).toUpperCase() || '?'}
            </div>
            <div className="customer-profile-info" style={{ flex: 1 }}>
              <div style={{ marginBottom: '1rem' }}>
                <h2 style={{ margin: '0 0 0.5rem', fontSize: '28px' }}>
                  {customer.name || 'İsimsiz Müşteri'}
                </h2>
                {isVIP && (
                  <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                    color: 'white',
                    padding: '0.5rem 1rem',
                    borderRadius: '12px',
                    fontSize: '14px',
                    fontWeight: '700'
                  }}>
                    <Gift size={18} /> VIP Müşteri
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '14px' }}>
                  <Mail size={16} />
                  <span>{customer.email || 'Email yok'}</span>
                </div>
                {customer.phone && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '14px' }}>
                    <Phone size={16} />
                    <span>{customer.phone}</span>
                  </div>
                )}
                {customer.address && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '14px' }}>
                    <MapPin size={16} />
                    <span>{customer.address}</span>
                  </div>
                )}
                {customer.city && customer.district && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '14px' }}>
                    <MapPin size={16} />
                    <span>{customer.district} / {customer.city}</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Customer Stats */}
          <div className="customer-stats-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '1rem',
            marginBottom: '2rem'
          }}>
            <div className="stat-box" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              padding: '1.5rem',
              background: 'white',
              border: '2px solid #e9ecef',
              borderRadius: '12px'
            }}>
              <Package size={24} color="#2196F3" />
              <div>
                <strong style={{ fontSize: '20px', display: 'block' }}>
                  {customerStats.totalOrders}
                </strong>
                <span style={{ fontSize: '13px', color: '#868e96' }}>Toplam Sipariş</span>
              </div>
            </div>
            <div className="stat-box" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              padding: '1.5rem',
              background: 'white',
              border: '2px solid #e9ecef',
              borderRadius: '12px'
            }}>
              <DollarSign size={24} color="#4CAF50" />
              <div>
                <strong style={{ fontSize: '20px', display: 'block' }}>
                  {customerStats.totalSpent.toFixed(2)}₺
                </strong>
                <span style={{ fontSize: '13px', color: '#868e96' }}>Toplam Harcama</span>
              </div>
            </div>
            <div className="stat-box" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              padding: '1.5rem',
              background: 'white',
              border: '2px solid #e9ecef',
              borderRadius: '12px'
            }}>
              <TrendingUp size={24} color="#9C27B0" />
              <div>
                <strong style={{ fontSize: '20px', display: 'block' }}>
                  {customerStats.avgOrderValue.toFixed(2)}₺
                </strong>
                <span style={{ fontSize: '13px', color: '#868e96' }}>Ortalama Sipariş</span>
              </div>
            </div>
            {customerStats.lastOrderDate && (
              <div className="stat-box" style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                padding: '1.5rem',
                background: 'white',
                border: '2px solid #e9ecef',
                borderRadius: '12px'
              }}>
                <Clock size={24} color="#FF9800" />
                <div>
                  <strong style={{ fontSize: '20px', display: 'block' }}>
                    {new Date(customerStats.lastOrderDate).toLocaleDateString('tr-TR')}
                  </strong>
                  <span style={{ fontSize: '13px', color: '#868e96' }}>Son Sipariş</span>
                </div>
              </div>
            )}
          </div>

          {/* Order History */}
          <div className="info-section">
            <h4>Sipariş Geçmişi ({orders.length})</h4>
            <div className="customer-orders-list" style={{
              maxHeight: '400px',
              overflowY: 'auto'
            }}>
              {orders.length === 0 ? (
                <div className="empty-orders" style={{
                  textAlign: 'center',
                  padding: '2rem',
                  color: '#868e96',
                  background: '#f8f9fa',
                  borderRadius: '8px'
                }}>
                  <Package size={48} style={{ opacity: 0.3, marginBottom: '1rem' }} />
                  <p>Henüz sipariş yok</p>
                </div>
              ) : (
                orders
                  .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                  .map(order => (
                    <div key={order.id} className="customer-order-item" style={{
                      padding: '1rem',
                      background: '#f8f9fa',
                      borderRadius: '8px',
                      marginBottom: '1rem',
                      border: '1px solid #e9ecef'
                    }}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '0.5rem'
                      }}>
                        <strong>#{order.orderNumber}</strong>
                        <span className={`status-badge status-${order.status}`} style={{
                          padding: '0.25rem 0.75rem',
                          borderRadius: '12px',
                          fontSize: '12px',
                          fontWeight: '600'
                        }}>
                          {order.status === 'pending' && '⏳ Beklemede'}
                          {order.status === 'processing' && '📦 Hazırlanıyor'}
                          {order.status === 'shipped' && '🚚 Kargoda'}
                          {order.status === 'delivered' && '✅ Teslim Edildi'}
                          {order.status === 'cancelled' && '❌ İptal'}
                          {order.status === 'returned' && '🔄 İade Edildi'}
                        </span>
                      </div>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontSize: '13px',
                        color: '#868e96'
                      }}>
                        <span>
                          {new Date(order.createdAt).toLocaleDateString('tr-TR', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </span>
                        <span>{order.items?.length || 0} ürün</span>
                      </div>
                      <div style={{
                        marginTop: '0.5rem',
                        paddingTop: '0.5rem',
                        borderTop: '1px solid #dee2e6',
                        display: 'flex',
                        justifyContent: 'flex-end'
                      }}>
                        <strong style={{ fontSize: '18px', color: '#E5332A' }}>
                          {order.total?.toFixed(2)}₺
                        </strong>
                      </div>
                    </div>
                  ))
              )}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
}

// ==================== RETURN APPROVAL MODAL ====================
export function ReturnApprovalModal({ orderId, onClose, onApprove }) {
  const [approvalData, setApprovalData] = useState({
    note: '',
    returnAddress: 'Trona Pazarlama İade Merkezi\nİstanbul, Türkiye',
    instructions: 'Lütfen ürünü orijinal ambalajında ve faturasıyla birlikte kargoya veriniz. Kargo ücreti tarafımızca karşılanacaktır.'
  });

  const handleSubmit = () => {
    if (!approvalData.returnAddress.trim()) {
      alert('Lütfen iade adresi giriniz!');
      return;
    }
    onApprove(approvalData);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <CheckCircle size={24} color="#4CAF50" />
            İade Talebini Onayla
          </h3>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">
          <div className="info-box" style={{
            background: '#d4edda',
            border: '2px solid #4CAF50',
            padding: '1rem',
            borderRadius: '8px',
            marginBottom: '1.5rem',
            display: 'flex',
            gap: '0.75rem'
          }}>
            <CheckCircle size={20} color="#4CAF50" />
            <div>
              <p style={{ margin: '0 0 0.5rem', fontSize: '14px', fontWeight: '600' }}>
                İade talebi onaylanacak
              </p>
              <p style={{ margin: 0, fontSize: '13px' }}>
                Müşteriye kargo bilgileri ve iade adresi gönderilecek.
              </p>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">İade Adresi *</label>
            <textarea
              className="form-input"
              placeholder="İade merkezi adresi..."
              rows="3"
              value={approvalData.returnAddress}
              onChange={(e) => setApprovalData({ ...approvalData, returnAddress: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Müşteri Talimatları *</label>
            <textarea
              className="form-input"
              placeholder="İade süreci için müşteri talimatları..."
              rows="4"
              value={approvalData.instructions}
              onChange={(e) => setApprovalData({ ...approvalData, instructions: e.target.value })}
            />
            <p style={{ fontSize: '12px', color: '#868e96', marginTop: '0.5rem' }}>
              Bu talimatlar müşteriye email olarak gönderilecektir.
            </p>
          </div>

          <div className="form-group">
            <label className="form-label">Admin Notu (Opsiyonel)</label>
            <textarea
              className="form-input"
              placeholder="İç not (müşteri görmez)..."
              rows="2"
              value={approvalData.note}
              onChange={(e) => setApprovalData({ ...approvalData, note: e.target.value })}
            />
          </div>

          <div className="info-box" style={{
            background: '#f8f9fa',
            border: '2px solid #e9ecef',
            padding: '1rem',
            borderRadius: '8px',
            marginTop: '1.5rem'
          }}>
            <h4 style={{ margin: '0 0 0.75rem', fontSize: '14px' }}>
              📋 İade Süreci Adımları:
            </h4>
            <ol style={{ margin: 0, paddingLeft: '1.25rem', fontSize: '13px', lineHeight: '1.8' }}>
              <li>İade talebi onaylanır</li>
              <li>Müşteriye email gönderilir (adres + talimatlar)</li>
              <li>Müşteri ürünü kargoya verir</li>
              <li>Ürün teslim alınır ve kontrol edilir</li>
              <li>Ödeme iadesi yapılır</li>
            </ol>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            Vazgeç
          </button>
          <button
            className="btn btn-success"
            onClick={handleSubmit}
          >
            <CheckCircle size={18} /> İade Talebini Onayla
          </button>
        </div>
      </div>
    </div>
  );
}

// ==================== RETURN RECEIVE MODAL ====================
export function ReturnReceiveModal({ orderId, onClose, onMarkReceived }) {
  const [receiptData, setReceiptData] = useState({
    productCondition: 'good',
    inspectionNote: ''
  });

  const conditionOptions = [
    { value: 'good', label: '✅ İyi Durumda', description: 'Ürün hasarsız, orijinal ambalajda' },
    { value: 'damaged', label: '⚠️ Hasarlı', description: 'Ürün kullanılabilir ama hasar var' },
    { value: 'defective', label: '❌ Kusurlu', description: 'Ürün kullanılamaz durumda' }
  ];

  const handleSubmit = () => {
    onMarkReceived(receiptData);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <Package size={24} color="#2196F3" />
            İade Ürünü Teslim Al
          </h3>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Ürün Durumu *</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              {conditionOptions.map(option => (
                <label
                  key={option.value}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '0.75rem',
                    padding: '1rem',
                    border: '2px solid',
                    borderColor: receiptData.productCondition === option.value ? '#2196F3' : '#e9ecef',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    background: receiptData.productCondition === option.value ? '#f0f7ff' : 'white',
                    transition: 'all 0.2s'
                  }}
                >
                  <input
                    type="radio"
                    name="productCondition"
                    value={option.value}
                    checked={receiptData.productCondition === option.value}
                    onChange={(e) => setReceiptData({ ...receiptData, productCondition: e.target.value })}
                    style={{ marginTop: '2px' }}
                  />
                  <div>
                    <div style={{ fontWeight: '600', marginBottom: '4px' }}>{option.label}</div>
                    <div style={{ fontSize: '13px', color: '#868e96' }}>{option.description}</div>
                  </div>
                </label>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Kontrol Notu</label>
            <textarea
              className="form-input"
              placeholder="İnceleme sonuçları ve notlar..."
              rows="4"
              value={receiptData.inspectionNote}
              onChange={(e) => setReceiptData({ ...receiptData, inspectionNote: e.target.value })}
            />
          </div>

          {receiptData.productCondition === 'good' && (
            <div className="info-box" style={{
              background: '#d4edda',
              border: '2px solid #4CAF50',
              padding: '1rem',
              borderRadius: '8px'
            }}>
              <p style={{ margin: 0, fontSize: '13px' }}>
                ✅ Ürün iyi durumda olduğu için stok otomatik geri yüklenecek.
              </p>
            </div>
          )}

          {(receiptData.productCondition === 'damaged' || receiptData.productCondition === 'defective') && (
            <div className="info-box" style={{
              background: '#fff3cd',
              border: '2px solid #ffc107',
              padding: '1rem',
              borderRadius: '8px'
            }}>
              <p style={{ margin: 0, fontSize: '13px' }}>
                ⚠️ Ürün hasarlı/kusurlu olduğu için stok geri yüklenmeyecek.
              </p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            Vazgeç
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            <Package size={18} /> Teslim Alındı Olarak İşaretle
          </button>
        </div>
      </div>
    </div>
  );
}

export default {
  ProductModal,
  CampaignModal,
  OrderDetailsModal,
  CustomerDetailsModal,
  ReturnApprovalModal,
  ReturnReceiveModal
};